import { render, staticRenderFns } from "./SourceScraperOverview.vue?vue&type=template&id=45e045b9&"
import script from "./SourceScraperOverview.vue?vue&type=script&lang=js&"
export * from "./SourceScraperOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports